import { gql } from '@apollo/client';

export const ADD_ACTIVITY_TO_USER = gql`
  mutation addActivityToUser($input: AddActivityToUserInput!) {
    user: addActivityToUser(input: $input) {
      id
    }
  }
`;
